<template>
    <main>
        <section class="">
            <div class="row">
                <div class="col-12 col-lg-12">
                    <div class="card shadow-sm rounded-3 h-100 card-script">
                        <div class="card-body p-4 text-center">
                            <h3 class="h5 mb-3"><strong>{{ $t("lang.elevenlab.call-script") }}</strong></h3>



                            <div v-if="attemptsLeft === 0" class="alert alert-secondary mt-3" role="alert">
                                {{ $t("lang.elevenlab.no-attempts") }}
                            </div>

                            <div v-else>
                                <div v-if="!convaiReady" class="text-muted py-4">{{ $t("lang.elevenlab.loading") }}
                                </div>

                                <div v-else-if="agentId" class="convai-wrap">
                                    <!-- IMPORTANTe: dynamic-variables (no "variables") y user-id -->
                                    <elevenlabs-convai ref="convai" :agent-id="agentId ? agentId : null" variant="full"
                                        open="true" :user-id="convaiUserId"></elevenlabs-convai>
                                </div>
                                <div v-else>
                                    <span>{{ $t("lang.elevenlab.no-agent") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-12 col-lg-12">
                    <div class="card shadow-sm rounded-3 h-100 card-script">
                        <div class="card-body p-4 text-center">
                            <Table class="table table-borderless">
                                <thead>
                                    <th>Date</th>
                                    <th>Booker</th>
                                    <th>Transcript</th>
                                    <th>Feedback</th>
                                </thead>
                                <tbody>
                                    <tr v-for="call in calls" :key="call.id">
                                        <td>{{ call.date }}</td>
                                        <td>{{ call.booker }}</td>
                                        <td><button class="btn btn-link"
                                                @click="openTranscriptModal(call.transcript)">Transcript</button></td>
                                        <td><button class="btn btn-link"
                                                @click="openFeedbackModal(call.feedback)">Feedback</button></td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Modal :name="'modalTranscript'" :size="'70'" :max-width="'650'" :close="true">
            <div class="transcript-container">
                <h5 class="mb-3">{{ $t("lang.elevenlab.conversation-transcript") }}</h5>
                <div class="conversation-messages" v-if="transcription && transcription.length">
                    <div v-for="(message, index) in transcription" :key="index"
                        :class="['message', message.role === 'agent' ? 'message-agent' : 'message-user']">
                        <div class="message-header">
                            <span class="message-role">
                                {{ message.role === 'agent' ? 'Agente' : 'Usuario' }}
                            </span>
                            <span class="message-time">
                                {{ formatTime(message.time_in_call_secs) }}
                            </span>
                        </div>
                        <div class="message-content">
                            {{ message.message }}
                        </div>
                    </div>
                </div>
                <div v-else class="text-muted text-center py-3">
                    No hay transcripción disponible
                </div>
            </div>
        </Modal>
        <Modal :name="'modalFeedback'" :size="'70'" :max-width="'650'" :close="true">
            <p>{{ feedbackText }}</p>
        </Modal>
    </main>
</template>
<script>
import { clientsService } from '@/_services';
import Modal from "@/components/Common/Modal.vue";
export default {
    components: { Modal },
    data() {
        return {
            feedbackText: '',
            transcription: {},
            agentId: null,
            attemptsLeft: 3,
            attemptsMax: 5,
            convaiReady: true,
            calls: [],
            user: {
                id: 1
            },
            convaiUserId: "user_123",
            convaiDynVarsJson: {}
        };
    },
    props: {
        booker_id: {
            type: String,
            required: true
        },
        client: {
            type: [Array, Object],
            required: true
        },
    },
    methods: {
        loadConvaiScriptOnce: async function () {
            var globalVars = {
                booker_external_id: this.bookerId,
                booker_name: this.fullName || null,
                booker_email: (this.user && this.user.email) || null,
                client_id: this.client.id || null,
            };
            window.ELEVENLABS_CONVAI_CONFIG = Object.assign(
                { hideDefaultLauncher: true, dynamicVariables: globalVars, variables: globalVars },
                window.ELEVENLABS_CONVAI_CONFIG || {}
            );

            if (window.customElements && window.customElements.get && window.customElements.get("elevenlabs-convai")) return true;

            var existing = document.querySelector('script[src*="@elevenlabs/convai-widget-embed"]');
            if (existing) {
                return await this.waitForCustomElement();
            }

            await new Promise(function (resolve, reject) {
                var s = document.createElement("script");
                s.src = "https://unpkg.com/@elevenlabs/convai-widget-embed@0.2.0/dist/index.js";
                s.async = true;
                s.onload = resolve;
                s.onerror = reject;
                document.head.appendChild(s);
            });

            return await this.waitForCustomElement();
        },
        waitForCustomElement: async function () {
            var t0 = Date.now();
            while (!(window.customElements && window.customElements.get && window.customElements.get("elevenlabs-convai"))) {
                if (Date.now() - t0 > 10000) throw new Error("ConvAI script load timeout");
                await new Promise(function (r) { setTimeout(r, 100); });
            }
            return true;
        },
        applyVarsToElement: function () {
            var el = this.$refs.convai;
            if (!el) return;

            var varsObj = {
                booker_external_id: this.bookerId,
                client_id: this.clientId,
            };

            try {
                el.userId = this.convaiUserId;
                el.dynamicVariables = varsObj;
                el.variables = varsObj;

                el.setAttribute("user-id", this.convaiUserId);
                el.setAttribute("dynamic-variables", JSON.stringify(varsObj));
                el.setAttribute("variables", JSON.stringify(varsObj));
            } catch (e) {
                console.warn("applyVarsToElement warn:", e);
            }
        },
        getElevenLabsCalls: async function () {
            try {
                const response = await clientsService.getElevenLabsCalls(this.client.id);
                if (response && response.calls) {
                    // Procesa las llamadas recibidas
                    this.calls = response.calls;
                    console.log("Llamadas de ElevenLabs:", response.calls);
                }
            } catch (error) {
                console.error("Error al obtener las llamadas de ElevenLabs:", error);
            }
        },

        openFeedbackModal(feedback) {
            this.feedbackText = feedback;
            this.$modal.show('modalFeedback');
        },
        openTranscriptModal(transcription) {
            this.transcription = transcription;
            this.$modal.show('modalTranscript');
        },

        formatTime(seconds) {
            if (!seconds && seconds !== 0) return '00:00';
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
    },
    mounted: async function () {

        this.agentId = this.client.elevenlab_agent_id
        this.getElevenLabsCalls()
        try {
            window.addEventListener('message', this.onConvaiMessage);

            await this.loadConvaiScriptOnce();
            this.convaiReady = true;

            var self = this;
            this.$nextTick(function () {
                self.applyVarsToElement();
            });
        } catch (e) {
            console.error("ConvAI load error:", e);
        }
    },
};
</script>
<style scoped>
.header-bg {
    background: #ffeaad;
}

.badge {
    font-size: 0.95rem;
}

.card {
    border: 1px solid #f1f1f1;
}

.table thead th {
    white-space: nowrap;
}

/* .gap-3 { gap: .75rem; } */

/* Centrado y tamaño del widget en su columna */
.convai-wrap {
    position: absolute;

    justify-content: center;
    align-items: center;
    padding: 1rem 0;
}

.card-script {
    position: relative;
    min-height: 300px;
    width: 100%;
    --gap: 12px;
    /* separación entre card y widget */
    --convai-h: 240px;
    /* alto estimado del widget (ajústalo) */
}

.card-script.show-convai {
    margin-bottom: calc(var(--convai-h) + var(--gap));
}

elevenlabs-convai {
    position: relative;
    justify-content: center;
    align-items: center;
    top: -400px;
    width: 80%;
    max-width: 400px;
    /* ancho máximo visual del widget */
    min-height: 520px;
    margin: 0 auto;
    /* centrado */

}

.transcript-container {
    padding: 1rem;
}

.conversation-messages {
    max-height: 400px;
    overflow-y: auto;
    padding: 0.5rem;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background-color: #f8f9fa;
}

.message {
    margin-bottom: 1rem;
    padding: 0.75rem;
    border-radius: 8px;
    max-width: 80%;
}

.message-agent {
    background-color: #e3f2fd;
    border-left: 4px solid #2196f3;
    margin-right: auto;
}

.message-user {
    background-color: #e8f5e8;
    border-left: 4px solid #4caf50;
    margin-left: auto;
}

.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
}

.message-role {
    font-weight: 600;
    color: #495057;
}

.message-time {
    color: #6c757d;
    font-size: 0.75rem;
}

.message-content {
    color: #212529;
    line-height: 1.4;
    word-wrap: break-word;
}

/* Scrollbar personalizada */
.conversation-messages::-webkit-scrollbar {
    width: 6px;
}

.conversation-messages::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.conversation-messages::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.conversation-messages::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
</style>